// Discord Community Hub - Full-width hub page linking to Revolt Discord
// Not a modal; standard hub layout with cover, info, and join CTA

const DISCORD_URL = 'https://discord.gg/W5aBdtegUU';

export function DiscordCommunityHub() {
  return (
    <div className="discord-hub">
      {/* Hero / cover section */}
      <section className="discord-hub-hero">
        <div className="discord-hub-hero-content">
          <div className="discord-hub-icon">
            <i className="fa-brands fa-discord" aria-hidden="true" />
          </div>
          <h1 className="discord-hub-title">Revolt Community on Discord</h1>
          <p className="discord-hub-subtitle">
            Join our Discord server for discussions, support, updates, and to connect with other Revolt users.
          </p>
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="discord-hub-cta"
          >
            <i className="fa-brands fa-discord" />
            Join Discord Server
          </a>
        </div>
      </section>

      {/* Info section */}
      <section className="discord-hub-info">
        <h2 className="discord-hub-section-title">What you&apos;ll find</h2>
        <div className="discord-hub-features">
          <div className="discord-hub-feature">
            <i className="fa-solid fa-comments" aria-hidden="true" />
            <span>Discussions &amp; Q&amp;A</span>
          </div>
          <div className="discord-hub-feature">
            <i className="fa-solid fa-life-ring" aria-hidden="true" />
            <span>Support &amp; help</span>
          </div>
          <div className="discord-hub-feature">
            <i className="fa-solid fa-bell" aria-hidden="true" />
            <span>Updates &amp; announcements</span>
          </div>
          <div className="discord-hub-feature">
            <i className="fa-solid fa-users" aria-hidden="true" />
            <span>Connect with the community</span>
          </div>
        </div>
      </section>
    </div>
  );
}
